<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/',title:'首页'},{title:'租赁测算'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">


            <!--表单-->
			<div class="h-piece" style="background: #fff;margin-bottom: 0.3rem;">
			
			    <el-switch
						v-if="shenpiyemian==false"
			            @click="choosetou"
			            v-model="moretou"
			            active-text="进行测算"
			            inactive-text="">
			    </el-switch>
            <div class="h-formLine ljjcesuan" v-if="moretou" style="background: #fff;">
				
                <el-form ref="form" :model="fin"
						style="box-shadow: none;border: none;padding-bottom: 0;"
                         :inline="true" class="demo-ruleForm h-formbLine h-piece">
					<el-form-item label="物料号" prop="z5" :rules="[
								  { required: true, message: '请输入z5_型号_型号名称', trigger: 'blur'},
								]" class="h-elformWrap-2">
					    <el-input v-model="fin.z5" disabled="disabled" style="width: 1.4rem;"></el-input>
					
					
					    <el-button class="h-btn h-bgblueQ2"
					               style="border-radius: 0.2rem;font-size: 0.2rem;margin-left: 0.1rem;padding: 0.05rem 0.1rem;"
					               type="primary"
					               @click="adds" v-if="shenpiyemian==false||tiaozhuancesuan">+
					    </el-button>
					
					</el-form-item>
                    <el-form-item label="客户" class="h-elformWrap-2" style="position:relative" prop="z20">
                        <el-input v-model="fin.z20" placeholder="请输入" readonly>

                            <i
                                    class="el-icon-search el-input__icon"
                                    slot="suffix"
                                    @click="tanchuxuanzeren" v-if="shenpiyemian==false||tiaozhuancesuan">
                            </i>

                        </el-input>
                    </el-form-item>



                    <el-form-item label="送达地址" class="h-elformWrap-2" prop="z19"
                                  :rules="[{ required: true, message: '请选择送达地址', trigger: 'change'},]">
                        <el-input clearable v-model="fin.z19" readonly>
                            <i
                                    class="el-icon-search el-input__icon"
                                    slot="suffix"
                                    @click="selectAreadialog" v-if="shenpiyemian==false">
                            </i>
                        </el-input>
                    </el-form-item>


                    <el-form-item label="送达城市" class="h-elformWrap-2" prop="z6"
                                  :rules="[{ required: true, message: '请选择地址', trigger: 'change'},]">


                        <el-select v-model="fin.z6" placeholder="送达地址带出" filterable clearable
                                   disabled="disabled">
                            <el-option
                                    v-for="(item,index) in songdachengshilist"
                                    :key="index"
                                    :label="`[${item.code}]${item.name}`"
                                    :value="item.code+'_'+item.name">
                            </el-option>
                        </el-select>


                    </el-form-item>


                    <el-form-item prop="z7" label="租期年限" :rules="[
								  { required: true, message: '请选择租期', trigger: 'change'},
								]" class="h-elformWrap-2">
                        <brselect clearable category="zuqi_cesuan" :v="fin.z7"
                                  v-model="fin.z7" :disabled="shenpiyemian==true"></brselect>
                    </el-form-item>

                    <el-form-item class="h-elformWrap-2 ljjrange" label="特价开始时间" prop="z8" :rules="[
								  { required: true, message: '请选择特价开始时间', trigger: 'blur'},
								]"
                    >
                        <el-col>

                            <el-date-picker type="date" placeholder="选择开始时间" v-model="fin.z8"
                                            :picker-options="pickerOptions" value-format="yyyy-MM-dd"
                                            :disabled="shenpiyemian==true"></el-date-picker>


                        </el-col>
                    </el-form-item>


                    <el-form-item label="第1年租金" prop="z10" :rules="[
								  { required: true, message: '请输入z10_第1年租金_第1年租金名称', trigger: 'blur'},
								]" class="h-elformWrap-2" v-if="fin.z7 ">
                        <el-input v-model="fin.z10"></el-input>
                    </el-form-item>
                    <el-form-item label="第2年租金" prop="z11" :rules="[
								  { required: true, message: '请输入z11_第2年租金_第2年租金名称', trigger: 'blur'},
								]" class="h-elformWrap-2" v-if="fin.z7 && fin.z7!=1">
                        <el-input v-model="fin.z11"></el-input>
                    </el-form-item>
                    <el-form-item label="第3年租金" prop="z12" :rules="[
								  { required: true, message: '请输入z12_第3年租金_第3年租金名称', trigger: 'blur'},
								]" class="h-elformWrap-2" v-if="fin.z7 && fin.z7!=1">
                        <el-input v-model="fin.z12"></el-input>
                    </el-form-item>
                    <el-form-item label="第4年租金" prop="z13" :rules="[
								  { required: true, message: '请输入z13_第4年租金_第4年租金名称', trigger: 'blur'},
								]" class="h-elformWrap-2" v-if="fin.z7 && fin.z7==5">
                        <el-input v-model="fin.z13"></el-input>
                    </el-form-item>
                    <el-form-item label="第5年租金" prop="z14" :rules="[
								  { required: true, message: '请输入z14_第5年租金_第5年租金名称', trigger: 'blur'},
								]" class="h-elformWrap-2" v-if="fin.z7 && fin.z7==5">
                        <el-input v-model="fin.z14"></el-input>
                    </el-form-item>


                    <div v-if="keyixianshijieguo">

                        <el-form-item label="租金总和" prop="z15" class="h-elformWrap-2">
                            <el-input v-model="fin.z15" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="成本价" prop="z1" class="h-elformWrap-2">
                            <el-input v-model="fin.z1" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="物流运费" prop="z2" class="h-elformWrap-2">
                            <el-input v-model="fin.z2" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="安装费" prop="z3" class="h-elformWrap-2">
                            <el-input v-model="fin.z3" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="成本价+物流运费+安装费总额" prop="z4" class="h-elformWrap-2">
                            <el-input v-model="fin.z4" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="内销一级经销商定价" prop="z9" class="h-elformWrap-2">
                            <el-input v-model="fin.z9" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="租赁盈利条件1不满足" prop="z16" class="h-elformWrap-1" v-if="fin.z16==0">
                            <el-input v-model="tiaojian1" disabled="disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="租赁盈利条件2不满足" prop="z17" class="h-elformWrap-1" v-if="fin.z17==0">
                            <el-input v-model="tiaojian2" disabled="disabled"></el-input>
                        </el-form-item>


                    </div>

                    


                    <div style="display: flex;justify-content: center;align-items: center;margin-top: 0.3rem;">
                        <el-button class="h-btn h-bBtn" @click="zulincesuan">测算</el-button>
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="chongzhi" v-if="shenpiyemian==false||tiaozhuancesuan">重置
                        </el-button>
						<el-button class="h-btn h-bBtn h-bgblue2"
						           @click="tijiao" v-if="shenpiyemian==false">
						    确认提交
						</el-button>
									
						<el-button class="h-btn h-bBtn h-bgblue2"
						           @click="chongxintijiao" v-if="bohuiyemian">
						    重新提交
						</el-button>

                    </div>

                </el-form>


                <div class="yxExtra" style="display: flex;justify-content: center;align-items: center;">
                    <div style="margin-bottom: 0.2rem;font-size: 0.3rem">{{cesuanjieguo}}</div>
                </div>

            </div>
			</div>
			<div class="h-table h-mrt30 bbbb" v-if="shenpiyemian==true||bohuiyemian==true" style="background: #fff;padding: 0.3rem;padding-bottom: 0.3rem;">
				<div class="h-pieceTitle2 hang" style="margin-bottom: 0;">
					<h1 class="h1">审批意见</h1>
					<el-form :model="shenpiyijian" label-position="right" :inline="true"
							 class="demo-ruleForm h-formbLine inputO">
						<el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
									  style="margin:30px 0 20px 0">
							<el-input v-if="shenpiyemian&&!bohuiyemian" v-model="shenpiyijian.msg"
									  placeholder="请输入"
									  class="zidaoO"></el-input>
							<el-input v-if="bohuiyemian" v-model="shenpiyijian.msg" class="zidaoO"
									  disabled></el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			
            <div v-if="shenpiyemian==false||tiaozhuancesuan">


                <!--查询表单-->
                <div class="h-piece">
                    <div class="h-formBox">
                        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="主键id">
								    <el-input v-model="q.id"></el-input>
								</el-form-item>
								<el-form-item label="成本价">
									<el-input v-model="q.z1"></el-input>
								</el-form-item>
								<el-form-item label="物流运费">
									<el-input v-model="q.z2"></el-input>
								</el-form-item>
								<el-form-item label="安装费">
									<el-input v-model="q.z3"></el-input>
								</el-form-item>
							</div>
							<el-collapse-transition>
								<div v-show="isScreen">
									<div class="h-thirdColumn w-newColumn">
										<el-form-item label="型号">
											<el-input v-model="q.z5"></el-input>
										</el-form-item>
										<el-form-item label="地址">
											<el-input v-model="q.z6"></el-input>
										</el-form-item>
										<el-form-item label="租期年限">
											<el-input v-model="q.z7"></el-input>
										</el-form-item>
										<el-form-item label="　　特价开始时间">
											<el-input v-model="q.z8"></el-input>
										</el-form-item>
									</div>
									<div class="h-thirdColumn w-newColumn">
										<el-form-item label="第1年租金">
											<el-input v-model="q.z10"></el-input>
										</el-form-item>
										<el-form-item label="第2年租金">
											<el-input v-model="q.z11"></el-input>
										</el-form-item>
										<el-form-item label="第3年租金">
											<el-input v-model="q.z12"></el-input>
										</el-form-item>
										<el-form-item label="第4年租金">
											<el-input v-model="q.z13"></el-input>
										</el-form-item>
									</div>
									<div class="h-thirdColumn w-newColumn">
										<el-form-item label="第5年租金">
											<el-input v-model="q.z14"></el-input>
										</el-form-item>
										<el-form-item label="使用人usercode">
											<el-input v-model="q.z18"></el-input>
										</el-form-item>
										<el-form-item label="是否满足盈利条件2">
											<brselect category="shifou_keyong" :v="q.z17" v-model="q.z17" clearable></brselect>
										</el-form-item>
										<el-form-item label="送达地址">
											<el-input v-model="q.z19"></el-input>
										</el-form-item>
									</div>
									<div class="h-thirdColumn w-newColumn">
										<el-form-item label="使用人username">
											<el-input v-model="q.z20"></el-input>
										</el-form-item>
										<el-form-item label="是否满足盈利条件1">
											<brselect category="shifou_keyong" :v="q.z16" v-model="q.z16" clearable></brselect>
										</el-form-item>
										<el-form-item label="租金总和">
											<el-input v-model="q.z15"></el-input>
										</el-form-item>
										<el-form-item label="　　内销一级经销商定价">
											<el-input v-model="q.z9"></el-input>
										</el-form-item>
									</div>
									<div class="h-thirdColumn w-newColumn">
										<el-form-item label="成本价+物流运费+安装费总额">
											<el-input v-model="q.z4"></el-input>
										</el-form-item>
									</div>
								</div>
							</el-collapse-transition>
							
							<!-- <div class="h-formBtnOut h-columnCenter">
							    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							    <el-button class="h-btn h-formBtn h-bgwhite" @click="xiabiaochongzhi">重置
							    </el-button>
							</div> -->
                        </el-form>
						<div class="l-screenBox">
							<div class="l-screen" @click="collapseChange">
								<img :src="isScreen?closeScreen:drawScreen" alt="">
								<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
							</div>
							<div class="l-retrieval">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="xiabiaochongzhi">重置
								</el-button>
							</div>
						</div>
                    </div>
                </div>


                <!--展示表格-->
                <div class="h-table h-mrt30">
                    <el-table
                            ref="ddtable"
                            :data="tableData"
                            stripe
                            style="width: 100%"
							:border="true"
							max-height="600"
                    >

                        <el-table-column
                                prop="id"
                                label="主键id"
								:show-overflow-tooltip="true"
                                width="170">
								<template scope="scope">
								    <div style="text-align: left;">
										{{scope.row.id}}
									</div>
								</template>
                        </el-table-column>

                        <el-table-column
                                prop="z1"
                                label="成本价"
								:show-overflow-tooltip="true"
                                width="90">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z1}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z2"
                                label="物流运费"
								:show-overflow-tooltip="true"
                                width="90">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z2}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z3"
                                label="安装费"
								:show-overflow-tooltip="true"
                                width="90">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z3}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z4"
                                label="成本价+物流运费+安装费总额"
								:show-overflow-tooltip="true"
                                width="240">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z4}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z5"
                                label="型号"
								:show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="z6"
                                label="地址"
								:show-overflow-tooltip="true"
                                width="140">
                        </el-table-column>
                        <el-table-column
                                prop="z7"
                                label="租期年限"
								:show-overflow-tooltip="true"
                                width="90">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z7}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z8"
                                label="特价开始时间"
								:show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="z9"
                                label="内销一级经销商定价"
								:show-overflow-tooltip="true"
                                width="170">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z9}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z10"
                                label="第1年租金"
								:show-overflow-tooltip="true"
                                width="100">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z10}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z11"
                                label="第2年租金"
								:show-overflow-tooltip="true"
                                width="100">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z11}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z12"
                                label="第3年租金"
								:show-overflow-tooltip="true"
                                width="100">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z12}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z13"
                                label="第4年租金"
								:show-overflow-tooltip="true"
                                width="100">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z13}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z14"
                                label="第5年租金"
								:show-overflow-tooltip="true"
                                width="100">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z14}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z15"
                                label="租金总和"
								:show-overflow-tooltip="true"
                                width="100">
								<template scope="scope">
								    <div style="text-align: right;">
										{{scope.row.z15}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z16"
                                label="是否满足盈利条件1"
								:show-overflow-tooltip="true"
                                width="160">
                            <template slot-scope="scope">
                                <dictname category="shifou_keyong"  :v="scope.row.z16"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="z17"
                                label="是否满足盈利条件2"
								:show-overflow-tooltip="true"
                                width="160">
                            <template slot-scope="scope">
                                <dictname category="shifou_keyong"  :v="scope.row.z17"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="z18"
                                label="使用人usercode"
								:show-overflow-tooltip="true"
                                width="160">
								<template scope="scope">
								    <div style="text-align: left;">
										{{scope.row.z18}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z19"
                                label="送达地址"
								:show-overflow-tooltip="true"
                                width="200">
								<template scope="scope">
								    <div style="text-align: left;">
										{{scope.row.z19}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="z20"
                                label="使用人username"
								:show-overflow-tooltip="true"
                                width="200">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.z20}}
									</div>
								</template>
                        </el-table-column>

                        <el-table-column
                                prop="cdate"
                                label="创建时间"
								:show-overflow-tooltip="true"
                                width="100">
                        </el-table-column>

                        <el-table-column
                                prop="ldate"
                                label="最后更新时间"
								:show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>

                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="120"
                        >
                            <template slot-scope="scope">

                                <!--                            <el-button-->
                                <!--                                    size="mini"-->
                                <!--                                    @click="handleEdit(scope.row)">编辑-->
                                <!--                            </el-button>-->
								<div class="w-caozuo" style="text-align: left;">
									<el-button
									        v-show="scope.row.instid"
									        size="small" class="h-tableLink h-btn"
									        @click="genzongLiuch(scope.row)">
									    跟踪
									</el-button>
									<el-button
									        size="small" class="h-tableLink h-btn"
									        @click="handleDelete(scope.row)">删除
									</el-button>
								</div>
                                
								<!-- <div class="l-operationBox">
									<span class="l-operationlist br-operation-spgz" v-show="scope.row.instid" title="跟踪审批" @click="genzongLiuch(scope.row)"></span>
									<span class="l-operationlist br-operation-delete" title="删除" @click="handleDelete(scope.row)"></span>
								</div> -->

                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                        <pagination :page="q" @query="query"/>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">导出</el-button>
                    </div>
                </div>


            </div>


            <div v-if="!zhidumoshi">

			<div style="display: flex;justify-content: center;align-items: center;margin-top: 0.5rem;">
			    <el-button
			            v-show="shenpiduixiang.instid"
			             class="h-bBtn h-btn"
			            @click="genzongLiuch(shenpiduixiang)" v-if="shenpiyemian==true||bohuiyemian==true">
			        跟踪审批
			    </el-button>
			    <el-button class="h-btn h-bBtn h-bggreen" @click="tongguoorbohui(2)"
			               v-if="shenpiyemian==true&&bohuiyemian==false">原版通过
			    </el-button>
			    <el-button class="h-btn h-bBtn h-bggreen" @click="gaishutongguo"
			               v-if="shenpiyemian==true&&bohuiyemian==false">改数直接通过
			    </el-button>
			    <el-button class="h-btn h-bBtn h-bgred" @click="tongguoorbohui(1)"
			               v-if="shenpiyemian==true&&bohuiyemian==false">驳回
			    </el-button>
			    
			
			</div>

        </div>


            <showxuanzerencesuan
                    :visible.sync="xuanzeren"
                    ddlx="2"
                    v-if="xuanzeren"
                    @choseObj="shiyongrenxuanze"
                    oneflag
                    title="选择经销商"/>


            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible1" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>新增测算型号</h1>
                            <p>New Calculation Model</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLines tan" style="margin-top: 0.3rem;">
                    <div>
                        <el-form :model="form" label-position=right ref="form" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <!-- <el-form-item label="大类" class="h-elformWrap-2" prop="dalei" :rules="[
                                    { required: true, message: '必须输入选项', trigger: 'blur'}]">
                                <el-select v-model="f.dalei" filterable @change="handleItemChange1" placeholder="大类">
                                    <el-option v-for="item in list1" :key="item.value" :label="item.prodseries" :value="item.oneLid">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="物料" class="h-elformWrap-2" prop="wuliao">
                                <el-select v-model="f.wuliao" filterable placeholder="物料">
                                    <el-option v-for="item in list2" :key="item.value" :label="item.promodel" :value="item.prodcode">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item label="大类" class="h-elformWrap-2" prop="dalei" :rules="[
										        { required: true, message: '必须输入选项', trigger: 'blur'}]"
                            >
                                <el-select v-model="form.dalei" filterable @change="handleItemChange1"
                                           placeholder="大类">
                                    <el-option
                                            v-for="item in list1"
                                            :key="item.value"
                                            :label="item.prodseries"
                                            :value="item.oneLid">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="物料" class="h-elformWrap-2" @change="changewuliao"
                            >
                                <el-select v-model="form.wuliao"
                                           filterable
                                           placeholder="物料">
                                    <el-option
                                            v-for="item in list2"
                                            :key="item.value"
                                            :label="`[${item.procategory}] [${item.prodcode}] ${item.promodel}`"
                                            :value="item.prodcode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="display:flex;justify-content:center;padding-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="queren">确认</el-button>
                    </div>
                </div>
            </el-dialog>


            <areaSelect
                    :visible.sync="showdizhiflag"
                    v-if="showdizhiflag"
                    @choseObj="choseDizhi"
            />


        </div>

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


    </div>
</template>
<script>
    import showxuanzerencesuan from '../../../components/dialog/selectshdfcesuan'
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile';
    import big from 'big.js'

    export default {
        components: {
            showxuanzerencesuan
        },
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                zhidumoshi:false,

                tiaozhuancesuan:false,

                shenpiyijian: {

                    optflag: '',
                    msg: '',
                    status: '',
                    id: '',
                    taskid: '',

                },

                bohuiyemian: false,


                shenpiduixiang: {},

                instid: '',

                showhistory: false,

                //审批页面
                shenpiyemian: false,

                tiaojian1: '第一年的租金必须大于成本价+物流运费+安装费总额',

                tiaojian2: '所有年限的总租金必须大于一级经销商定价的120%（1.2倍）',

                keyixianshijieguo: false,

                cesuanjieguo: '',

                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                },

                showdizhiflag: '',

                songdachengshilist: [],

                queryq: {
                    pcode: 0,
                    oneLid: '',
                },

                wuliaotext: '',

                list1: [],

                list2: [],

                form: {

                    dalei: '',
                    wuliao: '',

                },

                dialogFormVisible1: false,

                xuanzeren: false,

                moreCondition: false,

                moretou: false,


                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    id: "", // 主键id
                    cid: "", //测算保存合同更新信息id
                    z1: "", // z1_成本价_成本价--从SAP拿
                    z2: "", // z2_物流运费_物流运费--调接口获取
                    z3: "", // z3_安装费_安装费--从表拿
                    z4: "", // z1+z2+z3_成本价+物流运费+安装费_成本价+物流运费+安装费总额
                    z5: "", // z5_型号_型号
                    z6: "", // z6_地址_送达城市
                    z7: "", // z7_租期年限_租期年限  1  3  5年
                    z8: "", // z8_特价开始时间_特价开始时间
                    z9: "", // z9_内销一级经销商定价_内销一级经销商定价
                    z10: "", // z10_第1年租金_第1年租金
                    z11: "", // z11_第2年租金_第2年租金 /
                    z12: "", // z12_第3年租金_第3年租金 /
                    z13: "", // z13_第4年租金_第4年租金 /
                    z14: "", // z14_第5年租金_第5年租金 /
                    z15: "", // z10+z11+z12+z13+z14_租金总和_租金总和
                    z16: "", // z10>z4_成立条件1_成立条件1 /
                    z17: "", // z15>(z9*1.2)_成立条件2_成立条件2 /
                    z18: "", // 使用人usercode
                    z19: "",//送达地址
                    z20: "",// 使用人username
                    z21: "",//定价id
                },

                //表单
                fin: {

                    id: null, // 主键id
                    cid: null, //测算保存合同更新信息id
                    z1: null, // z1_成本价_成本价--从SAP拿
                    z2: null, // z2_物流运费_物流运费--调接口获取
                    z3: null, // z3_安装费_安装费--从表拿
                    z4: null, // z1+z2+z3_成本价+物流运费+安装费_成本价+物流运费+安装费总额
                    z5: null, // z5_型号_型号
                    z6: null, // z6_地址_送达城市
                    z7: null, // z7_租期年限_租期年限  1  3  5年
                    z8: null, // z8_特价开始时间_特价开始时间
                    z9: null, // z9_内销一级经销商定价_内销一级经销商定价
                    z10: null, // z10_第1年租金_第1年租金
                    z11: null, // z11_第2年租金_第2年租金 /
                    z12: null, // z12_第3年租金_第3年租金 /
                    z13: null, // z13_第4年租金_第4年租金 /
                    z14: null, // z14_第5年租金_第5年租金 /
                    z15: null, // z10+z11+z12+z13+z14_租金总和_租金总和
                    z16: null, // z10>z4_成立条件1_成立条件1 /
                    z17: null, // z15>(z9*1.2)_成立条件2_成立条件2 /
                    z18: null, // 使用人usercode
                    z19: null,//送达地址
                    z20: null,// 使用人username
                    z21: null,//定价id

                },
                //table列表
                tableData: [],
                //操作标志
                optflag: 'save',
            }
        },
        created() {

            this.query();

            //加载物料选择
            this.loadArea(1);

            //获取送达城市
            this.getsongdachengshilist();

            //审批加载
            this.shenpijiazai();

            //跳转加载
            this.yemiantiaozhuan();

        },


        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            //页面跳转的加载
            yemiantiaozhuan(){

                //使用人和物料号传了说明是跳转来测算的
                if (this.$route.query.z18&&this.$route.query.z5) {

                    //获取使用人user
                    ss.FormulaZulin.getusershiti({usercode:this.$route.query.z18}).then(rd => {

                        //查到使用人
                        if(rd.f==true&&(JSON.stringify(rd.obj) != '{}')){

                            //跳转测算页面
                            this.tiaozhuancesuan = true;

                            //上部展开测算
                            this.moretou = true;

                            //测算保存合同更新信息id
                            this.fin.cid = this.$route.query.cid;

                            //物料号
                            this.fin.z5 = this.$route.query.z5;

                            //使用人usercode
                            this.fin.z18 = this.$route.query.z18;

                            //使用人username
                            this.fin.z20 = rd.obj.username;

                            //租期年限1  3  5
                            this.fin.z7 = this.$route.query.z7;

                            //如果是1年
                            if(this.$route.query.z7=='1'){

                                this.fin.z10 =this.$route.query.z10;

                            //如果是3年
                            }else if(this.$route.query.z7=='3'){

                                this.fin.z10 =this.$route.query.z10;
                                this.fin.z11 =this.$route.query.z11;
                                this.fin.z12 =this.$route.query.z12;

                            //如果是5年
                            }else if(this.$route.query.z7=='5'){

                                this.fin.z10 =this.$route.query.z10;
                                this.fin.z11 =this.$route.query.z11;
                                this.fin.z12 =this.$route.query.z12;
                                this.fin.z13 =this.$route.query.z13;
                                this.fin.z14 =this.$route.query.z14;

                            }

                            //特价开始时间
                            this.fin.z8 =this.$route.query.z8;

                        }else{

                            this.$msg.msge("查无此使用人")

                        }


                    })

                }

            },


            //改数通过
            gaishutongguo() {


                var q = {

                    optflag :"通过",
                    msg:this.shenpiyijian.msg,
                    status:"2",
                    zaitijiaostatus:"2",

                }

                this.tijiaoagein(q);

            },


            //通过2或驳回1
            tongguoorbohui(q) {


                //通过
                if (q == 2) {

                    this.shenpiyijian.optflag = '通过'
                    this.shenpiyijian.status = 2

                    //驳回
                } else if (q == 1) {

                    this.shenpiyijian.optflag = '驳回'
                    this.shenpiyijian.status = 1

                }

                this.shenpiyijian.id = this.$route.query.ywid
                this.shenpiyijian.taskid = this.$route.query.taskid

                //通过审批
                ss.FormulaZulin.wanchengshenpi(this.shenpiyijian).then(rd => {

                    console.log(rd, 'rd')

                    if (rd.f == true) {

                        //成功后跳转
                        this.tijiaochenggong();

                    }


                })


            },


            //成功后跳转
            tijiaochenggong() {

                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({path: '/personal/dealCenter'})
                })

            },




            jiazaikaishi(q){

                var qq = {

                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    id: q,

                };

                ss.FormulaZulin.zulinshitiselectPage(qq).then(rd => {

                    var s = false;


                    for (var c in rd.records) {

                        if (rd.records[c].id == q) {

                            s = true;

                            this.fin = rd.records[c];

                        }

                    }

                    if (s == true) {

                        this.xianshicesuanjieguo();

                        this.shenpiyemian = true;

                        if(this.fin.instid){

                            this.instid = this.fin.instid;

                        }

                        if (this.fin.status == 1) {

                            this.bohuiyemian = true;

                            this.shenpiyijian = {

                                optflag: '驳回',
                                msg: this.fin.shenpijindu.split("_")[2],
                                status: 1,
                                id: this.fin.id,
                                taskid: this.$route.query.taskid,

                            };

                        }


                        this.moretou = true;
                        this.keyixianshijieguo = true;

                    } else {

                        this.msg.msge("没有该审批信息");
                        this.$router.push({path: "/personal/dealCenter"})

                    }

                })

            },


            //审批加载
            shenpijiazai() {

                if (this.$route.query.ywid) {

                    this.shenpiduixiang = this.$route.query;

                    console.log(this.$route.query, 'this.$route.query')

                    this.jiazaikaishi(this.$route.query.ywid);

                }

                if(this.$route.query.chakanshiti && this.$route.query.chakanshiti!=''){

                    console.log(this.$route.query, 'this.$route.query')

                    this.jiazaikaishi(this.$route.query.chakanshiti);

                }


            },


            //跟踪审批
            genzongLiuch(r) {
                this.instid = r.instid;
                this.showhistory = true;
            },

            //批量导出
            exportExcel() {
            	console.log(this.q);
                updownfile.down('/api/swyl/v1/zulinshiti/rateFormulaZulinshiti/downloadExcel',this.q);

            },


            //逻辑删除
            handleDelete(q) {

                this.$confirm('确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {

                        var s = {
                            id: q.id,
                            delflag: 0,
                        }


                        ss.FormulaZulin.baocunxinxi(s).then(rd => {

                            if (rd.f == true) {

                                this.$msg.msgs("删除成功");

                                //刷新列表
                                this.shuaxinliebiao();

                            }

                        })


                    })
                    .catch(_ => {

                    });


            },


            //编辑
            handleEdit(q) {

                console.log(q, 'qqqq')

                this.fin.id = q.id;
                this.fin.cid = q.cid;
                this.fin.z5 = q.z5;
                this.fin.z6 = q.z6;
                this.fin.z7 = q.z7;
                this.fin.z8 = q.z8;
                this.fin.z10 = q.z10;
                this.fin.z18 = q.z18;
                this.fin.z19 = q.z19;
                this.fin.z20 = q.z20;
                this.fin.z21 = q.z21;

            },


            //循环判断
            xunhuanjiancha() {

                var yes = true;

                for (var d in this.fin) {

                    if (d != 'z11' && d != 'z12' && d != 'z13' && d != 'z14' && d != 'z16' && d != 'z17' ) {

                        if (( this.fin[d] == null || this.fin[d] == '' ) && this.fin[d]!=0) {

                            console.log(d,"d")

                            console.log(this.fin[d],"this.fin[d]")

                            yes = false;

                        }

                    }

                }

                return yes;

            },


            tijiaoagein(q){

                if (this.xunhuanjiancha() == true) {


                    this.fin.optflag = q.optflag;
                    this.fin.msg = q.msg;
                    this.fin.status = q.status;
                    this.fin.zaitijiaostatus = q.zaitijiaostatus;


                    this.fin.taskid = this.$route.query.taskid;


                    ss.FormulaZulin.chongxintijiao(this.fin).then(rd => {

                        console.log(rd, 'rd')

                        if (rd.f == true) {

                            this.$msg.msgs("提交成功")

                            //成功后跳转
                            this.tijiaochenggong();

                        }


                    })

                } else {

                    this.$msg.msge("请保证提交信息完整性")

                }

            },


            //重新提交
            chongxintijiao() {

                var q = {

                    optflag :"通过",
                    msg:"重新提交",
                    status:"0",
                    zaitijiaostatus:"2",

                }

                this.tijiaoagein(q);

            },


            //提交
            tijiao() {

                if (this.xunhuanjiancha() == true) {

                    ss.FormulaZulin.baocunxinxi(this.fin).then(rd => {

                        console.log(rd, 'rd')

                        if (rd.f == true) {

                            this.$msg.msgs("提交成功")

                            //刷新列表
                            this.shuaxinliebiao();

                        }

                    })

                } else {

                    this.$msg.msge("请保证提交信息完整性")

                }

            },


            //下部重置按钮
            xiabiaochongzhi() {

                //刷新全表
                this.shuaxinliebiao();

            },


            //重置
            chongzhi() {

                this.fin = {

                    id: '',//id
                  
                    z1: '', // z1_成本价_成本价--从SAP拿
                    z2: '', // z2_物流运费_物流运费--调接口获取
                    z3: '', // z3_安装费_安装费--从表拿
                    z4: '', // z1+z2+z3_成本价+物流运费+安装费_成本价+物流运费+安装费总额
                    z5: '', // z5_型号_型号
                    z6: '', // z6_地址_送达城市
                    z7: '', // z7_租期年限_租期年限  1  3  5年
                    z8: '', // z8_特价开始时间_特价开始时间
                    z9: '', // z9_内销一级经销商定价_内销一级经销商定价
                    z10: '', // z10_第1年租金_第1年租金
                    z11: '', // z11_第2年租金_第2年租金
                    z12: '', // z12_第3年租金_第3年租金
                    z13: '', // z13_第4年租金_第4年租金
                    z14: '', // z14_第5年租金_第5年租金
                    z15: '', // z10+z11+z12+z13+z14_租金总和_租金总和
                    z16: '', // z10>z4_成立条件1_成立条件1
                    z17: '', // z15>(z9*1.2)_成立条件2_成立条件2
                    z18: '', // 使用人usercode
                    z19: '',//送达地址
                    z20: '',// 使用人username
                   

                };

                this.keyixianshijieguo = false;

                this.cesuanjieguo = '';

            },


            //公式处理
            gongshichuli() {

                //计算z15租金总额
                if (!this.fin.z10) {

                    this.$msg.msge("请输入租金");

                } else {

                    this.fin.z15 = new big(this.fin.z10).plus(this.fin.z11 || 0).plus(this.fin.z12 || 0).plus(this.fin.z13 || 0).plus(this.fin.z14 || 0).toString();

                }


                //计算z4总额
                if (!this.fin.z1) {

                    this.$msg.msge("SAP没有该物料成本价");

                } else {

                    this.fin.z4 = new big(this.fin.z1).plus(this.fin.z2 || 0).plus(this.fin.z3 || 0).toString();

                }


            },


            //判断条件
            panduantiaojian() {

                //判断条件1
                if (this.fin.z10 != null && this.fin.z10 != '' && this.fin.z4 != null && this.fin.z4 != '') {

                    this.fin.z16 = parseFloat(this.fin.z10) > parseFloat(this.fin.z4) ? '1' : '0';

                }

                //判断条件2
                if (this.fin.z15 != null && this.fin.z15 != '' && this.fin.z9 != null && this.fin.z9 != '') {

                    this.fin.z17 = parseFloat(this.fin.z15) > parseFloat(new big(this.fin.z9).times(1.2)) ? '1' : '0';


                }

            },


            //显示结果
            xianshicesuanjieguo() {

                console.log(this.fin, '结果+++')

                if (this.fin.z16 != null && this.fin.z16 != '' && this.fin.z16 == '1' && this.fin.z17 != null && this.fin.z17 != '' && this.fin.z17 == '1') {

                    this.cesuanjieguo = '满足租赁盈利条件';

                } else {

                    this.cesuanjieguo = '不满足租赁盈利条件';

                }

            },


            //测算
            zulincesuan() {

                console.log(this.fin, 'this.finaaa')


                ss.FormulaZulin.huoqujibenjine(this.fin).then(rd => {

                    console.log(rd.obj, 'rdsss')

                    if (rd.f == true) {

                        //返回的重新赋值
                        this.fin = rd.obj;

                        //处理公式
                        this.gongshichuli();

                        //判断条件
                        this.panduantiaojian();

                        //显示结果
                        this.xianshicesuanjieguo();

                        this.keyixianshijieguo = true;

                    }


                })


            },


            //获取送达城市
            getsongdachengshilist() {

                ss.Dictservice.listbycategory("pscode_cesuan").then(rd => {

                    this.songdachengshilist = rd;

                })

            },


            //选地址
            choseDizhi(obj) {


                this.fin.z6 = obj.quobj.pscode ? (obj.quobj.pscode + "_" + obj.quobj.name) : obj.shiobj.pscode ? (obj.shiobj.pscode + "_" + obj.shiobj.name) : null;

                this.fin.z19 = obj.quobj.namepath;

                if (obj.zhenobj) {

                    this.fin.z19 = obj.zhenobj.namepath;

                }

                this.fin.z19 = this.fin.z19 + obj.addrdetail;


                this.showdizhiflag = false;
            },

            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },

            //选物料
            xuanzewuliao() {

                this.$refs.form.validate((valid) => {

                    if (valid) {


                        this.form.daleiobj = _.find(this.list1, {oneLid: this.form.dalei});
                        this.form.wuliaoobj = _.find(this.list2, {prodcode: this.form.wuliao});

                        this.fin.z5 = this.form.wuliao;

                        console.log(this.form.wuliao, 'this.form.wuliao')


                    }

                });

            },

            //选物料
            adds() {
                this.dialogFormVisible1 = true;
            },

            // 确认物料
            queren() {

                if (this.form.dalei && this.form.wuliao) {

                    this.xuanzewuliao();

                    this.dialogFormVisible1 = false;

                } else {

                    this.$msg.msge("请选择大类和物料再进行确认")

                }
            },

            handleItemChange1(val) {

                this.queryq.pcode = null;
                this.queryq.oneLid = val;
                this.loadArea(2)

            },

            //加载大类物料
            loadArea(i) {
                ss.chanpin.idselectList(this.queryq).then(rd => {

                    this['list' + i] = rd;

                })
            },

            // 某一条物料编码
            changewuliao(v) {
                this.wuliaotext = v;
            },

            cancel() {
                this.f = {}
                this.dialogFormVisible1 = false;
            },

            tanchuxuanzeren() {
                this.xuanzeren = true;
            },

            //选择使用人
            shiyongrenxuanze(val) {
                console.log(val, '+++使用人')
                this.xuanzeren = false;
                this.fin.z20 = val.username;
                this.fin.z18 = val.usercode;

            },

            choosetou() {
                if (this.moretou) {
                    this.moretou = false;
                } else {
                    this.moretou = true;
                }
            },

            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                }
            },


            query() {

                ss.FormulaZulin.zulinshitiselectPage(this.q).then(rd => {

                    this.q.total = rd.total;
                    this.tableData = rd.records;

                })
            },


            //刷新列表
            shuaxinliebiao() {

                //上部重置
                this.chongzhi();

                this.q = {

                    pageSize: 10,
                    pageNo: 1,
                    total: 0,

                };

                //列表重置
                this.query();

                //关测算头
                this.moretou = false;

            },


            handleFilter() {

                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;

                this.query();
            },

        }
    }
</script>
<style scoped>
	
</style>
<style>
	.ljjcesuan .h-formbLine .h-elformWrap-2{
		width: 33.333%;
	}
	.ljjcesuan .h-formbLine .el-form-item__label{
		width: 40%;
	}
	.ljjcesuan .h-formbLine .el-form-item__content{
		width: 60%;
	}
	.ljjcesuan .h-formbLine .h-elformWrap-1 .el-form-item__label{
		width: 11.5%;
	}
	.ljjcesuan .h-formbLine .h-elformWrap-1 .el-form-item__content{
		width: 88.5%;
	}
	.tan .h-formbLine .el-form-item__label {
	    width: 47%;
	}
	
	.tan .h-formbLine .el-form-item__content {
	    width: 53%
	}
	
	.tan .h-formbLine .h-elformWrap-2 {
	    width: 50%;
	}
	
	.tan .h-elformWrap-1 .el-form-item__label {
	    width: 20%;
	}
	
	.tan .h-elformWrap-1 .el-form-item__content {
	    width: 80%;
	}
	.hang .h-formbLine .el-form-item__label{
		width: 20%;
	}
</style>